import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import CommonHeader from '../../base/views/CommonHeader';
import ApiService from '../../base/api/ApiService';
import { Announcement } from '../../components/models/Announcement';

const AnnouncementsPage: React.FC = () => {
    const navigate = useNavigate();
    const [announcements, setAnnouncements] = useState<Announcement[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        ApiService.getActiveAnnouncements()
            .then(setAnnouncements)
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <Box display="flex" justifyContent="center" mt={4}><CircularProgress /></Box>;
    }

    return (
        <div>
            <CommonHeader title="Объявления" showBackButton={false} />
            {announcements.length === 0 && (
                <Typography color="textSecondary" sx={{ p: 2 }}>Нет активных объявлений</Typography>
            )}
            {announcements.map((a) => (
                <Card
                    key={a.id}
                    sx={{
                        m: '5px',
                        cursor: 'pointer',
                        borderLeft: a.isRead ? '4px solid transparent' : '4px solid #fd5508'
                    }}
                    onClick={() => navigate(`/announcements/${a.id}`)}
                >
                    <CardContent>
                        <Typography variant="h6" fontWeight={a.isRead ? 'normal' : 'bold'}>
                            {a.name}
                        </Typography>
                        {a.startDate && (
                            <Typography variant="caption" color="textSecondary" display="block">
                                {format(new Date(a.startDate), 'd MMMM yyyy', { locale: ru })}
                            </Typography>
                        )}
                        {(a.announce || a.message) && (
                            <Typography
                                variant="body2"
                                mt={0.5}
                                sx={{
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical'
                                }}
                            >
                                {a.announce || a.message}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};

export default AnnouncementsPage;
